import Permissions from "@/constants/permissions";

/**
 * 좌측 메뉴에 대한 부분 입니다.
 * 매출 확인하고 거래처 관리부분, 메뉴얼 추가했습니다.
 * 권한 부분은 백에서 처리하는 부분이라 차후에 수정해야됩니다.
 *
 */
const SIDE_MENU = [
  {
    text: '업무 현황',
    permission: Permissions.SYSTEM.MEMBERSHIP,
    icon: 'mdi-view-dashboard-outline',
    id: 'managertnbox.dashboard',
  },
  {
    text: '업체 비교',
    permission: Permissions.SYSTEM.MEMBERSHIP,
    icon: 'mdi-compare',
    id: 'managertnbox.dashboard.rank',
  },
  {
    text: '회원관리', permission: Permissions.SYSTEM.MEMBERSHIP, icon: 'mdi-comment-alert', children: [
      {text: '임대업체관리', permission: Permissions.SYSTEM.MEMBERSHIP, id: 'managertnbox.membership.list'},
      {text: 'ERP 사용신청', permission: Permissions.SYSTEM.MEMBERSHIP, id: 'managertnbox.erp-application.list'},
      {text: "임대업체 통계", id: 'managertnbox.membership.stats'},
      {text: '임대업체 그룹', id: 'managertnbox.rental-company.manager.group.rentalcompany-group-list'},
      {text: "데이터 마이그레이션", id: "managertnbox.rental-company.manager.data-migration"},
      {text: '업무 대행 담당자', id: 'managertnbox.rental-company.manager.agency-manager.agency-manager'},
    ]
  },
  {
    text: 'MPS 요금', permission: Permissions.SYSTEM.MEMBERSHIP, icon: 'mdi-currency-krw', children: [
      {text: '기본요금제 관리', permission: Permissions.SYSTEM.MEMBERSHIP, id: 'managertnbox.payment.baseplan'},
      {text: '청구서 관리', permission: Permissions.SYSTEM.MEMBERSHIP, id: 'managertnbox.payment.mps-usage'},
    ]
  },
  {
    text: '다국어관리',
    permission: Permissions.SYSTEM.TRANSLATE,
    id: 'managertnbox.multilanguage.list',
    icon: 'mdi-format-font'
  },
  {
    text: '게시판', permission: Permissions.SYSTEM.BOARD, icon: 'mdi-comment-alert', children: [
      {text: "공지사항", permission: Permissions.SYSTEM.BOARD_NOTICE, id: 'managertnbox.board.list'},
      {text: "FAQ", permission: Permissions.SYSTEM.BOARD_FAQ, id: 'managertnbox.board.faq.list'},
    ]
  },
  {
    text: '메뉴얼', permission: Permissions.SYSTEM.MANUAL, icon: 'mdi-square-edit-outline ', children: [
      // {text: '메뉴얼 관리', id: 'managertnbox.manual.manage', permission: Permissions.SYSTEM.MANUAL_MANAGE},
      {text: '메뉴얼 관리', id: 'managertnbox.board.newmanage', permission: Permissions.SYSTEM.MANUAL_MANAGE},
      {text: '모바일 메뉴얼', id: 'managertnbox.board.mobile-manual', permission: Permissions.SYSTEM.MANUAL_MANAGE},
    ]
  },
  {
    text: 'Ai 관리', permission: Permissions.SYSTEM.MANUAL, icon: 'mdi-robot-outline', children: [
      {text: 'AI 호출 이력', id: 'managertnbox.ai-manage.call-history'},
      {text: '크레딧 관리', id: 'managertnbox.ai-manage.credit-manage'},
    ]
  },
  {
    text: '담당자 이메일 관리', permission: Permissions.SYSTEM.CHARGE_EMAIL, icon: 'mdi-square-edit-outline ', children: [
      {text: '회원가입 이메일 관리', id: 'managertnbox.charge-email.signup'},
    ]
  },
  {
    text: '시스템 유저', permission: Permissions.SYSTEM.SYSTEM_USER, icon: 'mdi-account-cog', children: [
      {text: "시스템유저 목록", permission: Permissions.SYSTEM.SYSTEM_USER_LIST, id: 'managertnbox.sysuser.list'},
      {text: "시스템유저 등록", permission: Permissions.SYSTEM.SYSTEM_USER_REGISTER, id: 'managertnbox.sysuser.register'},
    ]
  },
  {
    text: '모니터링', permission: Permissions.SYSTEM.MONITORING, icon: 'mdi-monitor', children: [
      {text: "Agent 배포", permission: Permissions.SYSTEM.MONITORING_DEPLOY, id: "managertnbox.monitoring.agent.deploy"},
      {
        text: "Agent 버전 관리",
        permission: Permissions.SYSTEM.MONITORING_VERSION_MANAGE,
        id: "managertnbox.monitoring.version"
      },
      {
        text: "Agent 전송 주기 설정",
        permission: Permissions.SYSTEM.MONITORING_CYCLE_CONFIG,
        id: "managertnbox.monitoring.agent.cycle.config"
      },
      {
        text: "Agent 전송 주기 관리",
        permission: Permissions.SYSTEM.MONITORING_CYCLE_MANAGE,
        id: "managertnbox.monitoring.agent.cycle.manage"
      },
      {
        text: "프린터 시리즈",
        permission: Permissions.SYSTEM.MONITORING_PRINTER_SERIES,
        id: "managertnbox.monitoring.printer.series"
      },
      {
        text: "드라이버 설치",
        permission: Permissions.SYSTEM.MONITORING_PRINTER_SERIES,
        id: "managertnbox.monitoring.printer.driver"
      },
      {
        text: "장치 목록",
        permission: Permissions.SYSTEM.MONITORING_PRINTER_SERIES,
        id: "managertnbox.monitoring.device.list"
      },
      {
        // TODO: 테스트용 하드코딩 — DB 권한(SYSTEM__MONITORING__MONITORING-SUPPLY) 등록 후 permission 복구
        text: "소모품 교체 현황",
        permission: Permissions.SYSTEM.MONITORING_PRINTER_SUPPLIES,
        id: "managertnbox.monitoring.supply.status"
      },
      {
        text: "출력량 현황",
        permission: Permissions.SYSTEM.MONITORING_PRINTER_SUPPLIES,
        id: "managertnbox.monitoring.print.volume"
      },
    ]
  },
  {
    text: '임대업체', permission: Permissions.SYSTEM.MANAGE_RENTAL, icon: 'mdi-office-building', children: [
      {
        text: '매출확인',
        permission: Permissions.SYSTEM.MANAGE_RENTAL,
        icon: 'mdi-brightness-auto',
        id: 'managertnbox.sales'
      },
      {
        text: '입출금 확인',
        permission: Permissions.SYSTEM.MANAGE_RENTAL,
        icon: 'mdi-brightness-auto',
        id: 'managertnbox.deposit'
      },
      {
        text: "거래처 관리",
        permission: Permissions.SYSTEM.MANAGE_RENTAL,
        icon: 'mdi-office-building',
        id: "managertnbox.account.management"
      },
    ]
  },
  {
    text: '시스템코드', permission: Permissions.SYSTEM.SYSTEM_CODE, icon: 'mdi-square-edit-outline ', children: [
      {text: '시스템코드 관리', id: 'managertnbox.syscode'},
      {text: '언어', id: 'managertnbox.syscode.language'},
    ]
  },
  {text: '배치', permission: Permissions.SYSTEM.TRANSLATE, id: 'managertnbox.batch', icon: 'mdi-brightness-auto', children: [
      {text: '배치 확인', id: 'managertnbox.batch'},
      {text: '배치 관리', id: 'managertnbox.batchmanager'},
    ]
  },
  {
    text: '시스템 권한', permission: Permissions.SYSTEM.SYSTEM_PERMISSION, icon: 'mdi-checkbox-marked-circle', children: [
      {
        text: "권한 관리",
        permission: Permissions.SYSTEM.SYSTEM_PERMISSION_MANAGE,
        id: 'managertnbox.permission.system.manage'
      },
      {
        text: "권한 그룹 관리",
        permission: Permissions.SYSTEM.SYSTEM_PERMISSION_GROUP_MANAGE,
        id: 'managertnbox.permission-group.system.manage'
      },
    ]
  },
];

export default {
  SIDE_MENU
}
